import gql from 'graphql-tag';

export const GET_PARTNER_LINKS = gql`
  query GetDealerLinks($accountId: ID!, $withDealerMetaData: Boolean! = false) {
    aftermarketDealerPartnerLink(accountId: $accountId) {
      partnerLinkId
      name
      logo
      partnerProfile {
        name
        availableToPro
      }
      dealerMetaData @include(if: $withDealerMetaData) {
        isActive
      }
    }
  }
`;
